import { api } from 'components/api'
import { inboxConversationPath } from 'components/routes/api'
import type {
  ApiInboxConversationShowResponse,
  InboxConversationDetail
} from '../inboxTypes'
import { mapApiDetailToInboxDetail } from '../inboxTypes'

export const fetchInboxConversation = async (
  conversationId: number
): Promise<InboxConversationDetail> => {
  const response = await api.get<unknown, ApiInboxConversationShowResponse>({
    url: inboxConversationPath(conversationId),
    headers: { Accept: 'application/json' },
    cacheOptions: { enabled: false }
  })

  if (response.data.conversation == null) {
    throw new Error('Inbox conversation response is missing conversation')
  }

  return mapApiDetailToInboxDetail(response.data.conversation)
}
